module.exports = __webpack_public_path__ + "img/empty_state.fd392d45.svg";